import { createUseStyles } from "react-jss";
import { grey1 } from "./theme";

const globalStyle = createUseStyles({
  "@global": {
    "*": {
      boxSizing: "border-box",
      margin: 0,
      padding: 0,
      listStyleType: "none",
    },
    "h1, h2, h3, h4, h5": {
      marginBottom: 0,
    },

    "body,body *:not([class*='customFont']):not([class*='customFont2']):not([class*='customFont'] *),button":
      {
        fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif !important",
      },
    p: {
      marginBottom: 0,
    },
    ".ant-modal .ant-btn-primary": {
      borderRadius: "8px !important",
      height: "42px !important",
      padding: "0 24px !important",
      background: "#1B2A6B !important",
      borderColor: "#1B2A6B !important",
      boxShadow: "0 4px 12px rgba(27,42,107,0.25) !important",
      transition: "transform 0.18s ease, box-shadow 0.18s ease !important",
    },
    ".ant-modal .ant-btn-primary:hover": {
      background: "#1B2A6B !important",
      borderColor: "#1B2A6B !important",
      opacity: "1 !important",
      filter: "none !important",
      transform: "translateY(-2px) !important",
      boxShadow: "0 7px 20px rgba(27,42,107,0.38) !important",
    },
    ".ant-modal .ant-btn-default": {
      borderRadius: "8px !important",
      height: "42px !important",
    },
    ".ant-popconfirm .ant-btn": {
      borderRadius: "6px !important",
      height: "28px !important",
      padding: "0 12px !important",
      fontSize: "0.8rem !important",
    },
    ".ant-popconfirm .ant-btn-primary": {
      background: "#1B2A6B !important",
      borderColor: "#1B2A6B !important",
    },
    ".ant-popconfirm .ant-btn-primary:hover": {
      background: "#1B2A6B !important",
      borderColor: "#1B2A6B !important",
      opacity: "1 !important",
      filter: "none !important",
    },
    ".ant-modal .ant-input-affix-wrapper": {
      borderRadius: "8px !important",
      height: "44px !important",
      background: "#f0f6fb !important",
      border: "1px solid #dde8f4 !important",
    },
    ".ant-modal .ant-input": {
      borderRadius: "8px !important",
      height: "44px !important",
      background: "#f0f6fb !important",
      border: "1px solid #dde8f4 !important",
    },
    ".ant-modal .ant-input-affix-wrapper .ant-input": {
      height: "auto !important",
      border: "none !important",
      background: "transparent !important",
      boxShadow: "none !important",
    },
    ".ant-modal .ant-input-group-wrapper": {
      height: "44px !important",
    },
    ".ant-modal .ant-input-group": {
      height: "44px !important",
      display: "flex !important",
      alignItems: "stretch !important",
    },
    ".ant-modal .ant-input-group-wrapper .ant-input-group .ant-input": {
      borderRadius: "0 !important",
      height: "100% !important",
      background: "#f0f6fb !important",
      border: "none !important",
    },
    ".ant-modal .ant-input-group-wrapper .ant-input-group .ant-input-affix-wrapper": {
      borderRadius: "0 8px 8px 0 !important",
      height: "44px !important",
      background: "#f0f6fb !important",
      border: "1px solid #dde8f4 !important",
      borderLeft: "none !important",
      boxShadow: "none !important",
    },
    ".ant-modal .ant-input-group-wrapper .ant-input-group-addon": {
      borderRadius: "8px 0 0 8px !important",
      background: "#e4edf6 !important",
      border: "1px solid #dde8f4 !important",
      borderRight: "none !important",
      display: "flex !important",
      alignItems: "center !important",
      justifyContent: "center !important",
      minWidth: "60px !important",
      padding: "0 12px !important",
      fontSize: "0.875rem !important",
      fontWeight: "600 !important",
      color: "#1B2A6B !important",
      flexShrink: "0 !important",
    },
    ".ant-modal .ant-select-single": {
      height: "45px !important",
    },
    ".ant-modal .ant-select-selector": {
      borderRadius: "8px !important",
      alignItems: "center !important",
      background: "#f0f6fb !important",
      border: "1px solid #dde8f4 !important",
      display: "flex !important",
    },
    ".ant-select-arrow": {
      insetInlineEnd: "11px !important",
      top: "50% !important",
      transform: "translateY(-50%) !important",
      marginTop: "0 !important",
      display: "flex !important",
      alignItems: "center !important",
      justifyContent: "center !important",
    },
    ".ant-modal .ant-picker": {
      borderRadius: "8px !important",
      height: "44px !important",
      background: "#f0f6fb !important",
      border: "1px solid #dde8f4 !important",
    },
    ".ant-btn-primary": {
      background: "linear-gradient(90deg, #1B2A6B 0%, #2563b8 100%) !important",
      borderColor: "transparent !important",
      borderRadius: "24px !important",
      fontWeight: "600 !important",
      boxShadow: "0 4px 12px rgba(27,42,107,0.25) !important",
      transition: "opacity 0.2s ease, box-shadow 0.2s ease !important",
    },
    ".ant-btn-primary:hover, .ant-btn-primary:focus": {
      opacity: "0.9 !important",
      boxShadow: "0 6px 16px rgba(27,42,107,0.35) !important",
    },
    ".ant-btn-primary:disabled, .ant-btn-primary.ant-btn-disabled": {
      opacity: "0.5 !important",
      boxShadow: "none !important",
    },
    ".ant-btn-default:disabled, .ant-btn-default.ant-btn-disabled": {
      background: "#f0f3f7 !important",
      borderColor: "#d8e2ec !important",
      color: "#bbc8d4 !important",
      opacity: "1 !important",
      cursor: "not-allowed !important",
    },
    "p, label": {},
    ".ant-input-affix-wrapper-focused": {
      boxShadow: "0 0 0 2px rgba(5,145,255,.1)",
    },
    'input[type="number"]::-webkit-outer-spin-button,input[type="number"]::-webkit-inner-spin-button':
      {
        "-webkit-appearance": "none",
        margin: 0,
      },
    ".ant-card": {
      overflow: "hidden",
    },
    ".ant-tabs": {
      gap: 24,
    },
    ".ant-tabs-tab-btn:focus, .ant-tabs-tab-btn:focus-visible": {
      outline: "none !important",
      boxShadow: "none !important",
    },
    ".ant-tag": {
      marginInlineEnd: 0,
    },
    ".ant-switch": {
      height: "28px !important",
      lineHeight: "28px !important",
      minWidth: "52px !important",
      borderRadius: "8px !important",
    },
    ".ant-switch.ant-switch-checked": {
      background: "#22c55e !important",
    },
    ".ant-switch.ant-switch-checked:hover:not(.ant-switch-disabled)": {
      background: "#16a34a !important",
    },
    ".ant-switch .ant-switch-handle": {
      width: "22px !important",
      height: "22px !important",
      top: "3px !important",
      insetInlineStart: "3px !important",
      borderRadius: "4px !important",
    },
    ".ant-switch .ant-switch-handle::before": {
      borderRadius: "4px !important",
    },
    ".ant-switch.ant-switch-checked .ant-switch-handle": {
      insetInlineStart: "calc(100% - 25px) !important",
    },
    ".ant-switch .ant-switch-inner": {
      padding: "0 !important",
    },
    ".ant-switch .ant-switch-inner .ant-switch-inner-checked": {
      display: "flex !important",
      alignItems: "center !important",
      justifyContent: "center !important",
      height: "28px !important",
      width: "28px !important",
      marginInlineStart: "0 !important",
      marginInlineEnd: "0 !important",
    },
    ".ant-switch .ant-switch-inner .ant-switch-inner-unchecked": {
      marginTop: "-28px !important",
      display: "flex !important",
      alignItems: "center !important",
      justifyContent: "center !important",
      height: "28px !important",
      width: "28px !important",
      marginInlineStart: "24px !important",
      marginInlineEnd: "0 !important",
    },
    ":where(.css-dev-only-do-not-override-1bu589w).ant-card .ant-card-cover img, :where(.css-dev-only-do-not-override-1bu589w).ant-card .ant-card-cover img+.ant-image-mask":
      {
        borderRadius: "unset",
      },
    ".ant-pagination": {
      fontSize: "0.8rem !important",
      alignItems: "center !important",
    },
    ".ant-pagination-total-text": {
      color: "#6b7a99 !important",
      fontSize: "0.8rem !important",
      marginRight: "auto !important",
    },
    ".ant-pagination-item": {
      minWidth: "28px !important",
      height: "28px !important",
      lineHeight: "26px !important",
      borderRadius: "6px !important",
      border: "1px solid #dde8f4 !important",
      fontSize: "0.8rem !important",
      marginInlineEnd: "4px !important",
    },
    ".ant-pagination-item a": {
      color: "#5a7a9a !important",
      fontSize: "0.8rem !important",
      lineHeight: "26px !important",
      padding: "0 4px !important",
    },
    ".ant-pagination-item:hover": {
      borderColor: "#00A9E0 !important",
    },
    ".ant-pagination-item:hover a": {
      color: "#00A9E0 !important",
    },
    ".ant-pagination .ant-pagination-item-active, .ant-pagination-item.ant-pagination-item-active": {
      background: "#00A9E0 !important",
      borderColor: "#00A9E0 !important",
      borderRadius: "6px !important",
    },
    ".ant-pagination .ant-pagination-item-active a, .ant-pagination-item.ant-pagination-item-active a": {
      color: "#ffffff !important",
    },
    ".ant-pagination-prev, .ant-pagination-next": {
      minWidth: "28px !important",
      height: "28px !important",
      lineHeight: "26px !important",
    },
    ".ant-pagination-prev .ant-pagination-item-link, .ant-pagination-next .ant-pagination-item-link": {
      border: "none !important",
      background: "transparent !important",
      borderRadius: "6px !important",
      color: "#8fa8bf !important",
      fontSize: "0.75rem !important",
      display: "flex !important",
      alignItems: "center !important",
      justifyContent: "center !important",
      height: "28px !important",
    },
    ".ant-pagination-prev:not(.ant-pagination-disabled):hover .ant-pagination-item-link, .ant-pagination-next:not(.ant-pagination-disabled):hover .ant-pagination-item-link": {
      color: "#00A9E0 !important",
    },
    ".ant-pagination-options": {
      display: "inline-flex !important",
      alignItems: "center !important",
    },
    ".ant-pagination-options .ant-select": {
      display: "inline-flex !important",
      alignItems: "center !important",
    },
    ".ant-pagination-options .ant-select-selector": {
      height: "28px !important",
      borderRadius: "8px !important",
      border: "1px solid #d0e6f5 !important",
      background: "#e8f3fb !important",
      alignItems: "center !important",
      display: "flex !important",
      paddingInline: "12px !important",
    },
    ".ant-pagination-options .ant-select-selection-item": {
      lineHeight: "26px !important",
      fontSize: "0.8rem !important",
      color: "#3a6a8a !important",
      fontWeight: "500 !important",
    },
    ".ant-pagination-options .ant-select-arrow": {
      color: "#5a7a9a !important",
    },
    "::-webkit-scrollbar": { width: "6px" },
    "::-webkit-scrollbar-track": {
      background: grey1,
    },
    "::-webkit-scrollbar-thumb": { background: "#c1c1c1" },
    "::-webkit-scrollbar-thumb:hover": { background: "#b1b1b1" },
    ".ql-editor": {
      minHeight: 250,
    },
    ".ant-modal .ql-editor": {
      minHeight: "120px !important",
    },
    ".ant-modal-root .ant-modal-content": {
      maxHeight: "calc(100vh - 80px) !important",
      display: "flex !important",
      flexDirection: "column !important",
      overflow: "hidden !important",
    },
    ".ant-modal-root .ant-modal-body textarea": {
      resize: "vertical !important",
      maxHeight: "500px !important",
    },
    ".ant-modal-root .ant-modal-header": {
      flexShrink: "0 !important",
    },
    ".ant-modal-root .ant-modal-body": {
      overflowY: "auto !important",
      overflowX: "hidden !important",
      flex: "1 1 auto !important",
    },
    ".ant-modal-root .ant-modal-footer": {
      flexShrink: "0 !important",
    },
  },
});

export default globalStyle;
